import React, { Component } from "react";
import {
  Button,
  Table,
  Alert,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Select from 'react-select';
import Pagination from "react-js-pagination";
import "react-confirm-alert/src/react-confirm-alert.css";
import { confirmAlert } from 'react-confirm-alert';

import { chuongTrinhListNhomKhRequest } from '../ChuongTrinh/actions'
import * as khachHangNhomAction from './actions'
import { customSelectStyles } from '../../lib/common';
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import NhomKhEdit from './_NhomKhEdit'

class KhachHangNhom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      isOpenDlg: false,
      nhomKh: [],
      setted: {
        page: 1,
        per_page: 50,
        total_record: 0,
        keyword: '',
        items: [],
      },
      unSetted: {
        page: 1,
        per_page: 50,
        total_record: 0,
        keyword: '',
        items: []
      },
      selectedOption: null,
      NhomKhId: 0,
      formError: []
    };
  }
  handleSearchChange = ({ target }, isSetted) => {
    if (isSetted) {
      let { setted } = this.state
      setted.keyword = target.value
      this.setState({ setted })
    } else {
      let { unSetted } = this.state
      unSetted.keyword = target.value
      this.setState({ unSetted })
    }
  }
  keyPress = (e, isSetted) => {
    if (e.keyCode == 13) {
      this.fetchDetails(isSetted)
    }
  }
  handleNhomKhChange = selectedOption => {
    this.setState({ selectedOption });
    this.setState({
      NhomKhId: selectedOption.value,
      setted: {
        page: 1,
        keyword: '',
      }
    }, () => {
      this.fetchDetails(true);
    });
  };
  handlePageChange = (pageNumber, isSetted) => {
    let { setted, unSetted } = this.state
    if (isSetted) {
      setted.page = pageNumber
      this.setState({ setted })
    } else {
      unSetted.page = pageNumber
      this.setState({ unSetted })
    }
    this.fetchDetails(isSetted);
  }
  fetchDetails = (isSetted, callback) => {
    let { setted, unSetted } = this.state
    let requestData = {
      nhomId: this.state.NhomKhId,
      isSetted,
      keyword: '',
      page: 1
    }
    if (isSetted) {
      requestData.page = setted.page
      requestData.keyword = setted.keyword
    } else {
      requestData.page = unSetted.page
      requestData.keyword = unSetted.keyword
    }
    const onSuccess = ({ page, per_page, total_record, items }) => {
      if (items) {
        if (isSetted) {
          setted = { ...setted, page, per_page, total_record, items }
          this.setState({ setted })
        } else {
          unSetted = { ...unSetted, page, per_page, total_record, items }
          this.setState({ unSetted })
        }
      } else {
        if (isSetted) {
          setted = { ...setted, page: 1, per_page, total_record, items: [] }
          this.setState({ setted })
        } else {
          unSetted = { ...unSetted, page: 1, per_page, total_record, items: [] }
          this.setState({ unSetted })
        }
      }
      if (callback) {
        callback()
      }
    }
    return this.props.khachHangNhomDetailRequest(requestData, onSuccess);
  }
  processUpdate = (ids, inSetted) => {
    let { formError, NhomKhId } = this.state, hadError = false
    formError = []
    var requestData = {
      nhomId: 0,
      itemIds: ids,
    }

    if (inSetted) {
      // da phan nhom can bo ra khoi nhom
      requestData.nhomId = 0
    } else {
      if (NhomKhId && NhomKhId > 0) {
        requestData.nhomId = NhomKhId
      } else {
        hadError = true
        formError.NhomKhId = "Bạn chưa chọn nhóm";
      }
    }

    if (requestData.itemIds.length == 0) {
      hadError = true
    }
    this.setState({ formError: formError })

    const callback = (isSuccess) => {
      if (isSuccess) {
        this.fetchDetails(false, () => this.fetchDetails(true))
      }
    }
    if (!hadError) {
      this.props.khachHangNhomUpdateRequest(requestData, callback)
    }
  }
  UpdateKhachHang = (res, inSetted) => {
    if (!res || !res.Id || res.Id == 0) {
      return false
    }
    this.processUpdate([res.Id], inSetted)
  }
  UpdateAll = (items, inSetted) => {
    const ids = items.map((item) => {
      return item.Id
    })
    this.processUpdate(ids, inSetted)
  }
  confirmBatchUpdateClick = (items, inSetted) => {
    if (!items || items.length === 0) {
      return false
    }
    const msg = inSetted ? `bỏ phân nhóm cho ${items.length}` : `phân nhóm cho ${items.length}`
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn muốn {msg} khách hàng này không?
            </p>
            <button className="text-danger" onClick={() => {
              this.UpdateAll(items, inSetted)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  getListNhomKh = (callback) => {
    var requestData = {}
    const onSuccess = ({ data }) => {
      if (data) {
        this.setState({ nhomKh: data })
      } else {
        this.setState({ nhomKh: [] })
      }
      if (typeof callback == 'function') {
        callback()
      }
    }
    this.props.chuongTrinhListNhomKhRequest(requestData, onSuccess);
  }
  updateDataFields = (data) => {
    this.setState({ item: data })
  }
  updateNhomKh = () => {
    let { item } = this.state
    const onSuccess = (data) => {
      if (data) {
        this.toggleNhomKhDlg()
        this.getListNhomKh()
        this.setState({ item: {} })
      }
    }
    this.props.updateNhomKhachHangInfo(item, onSuccess)
  }
  toggleNhomKhDlg = () => {
    let { isOpenDlg } = this.state
    this.setState({ isOpenDlg: !isOpenDlg })
  }
  componentDidMount() {
    this.getListNhomKh()
  }
  render() {
    const {
      selectedOption,
      nhomKh,
      setted,
      unSetted
    } = this.state;
    const {
      khachHangNhom: {
        listRequesting,
        requesting,
        messages,
        errors,
      },
    } = this.props

    const getOptionNhomKh = () => {
      var options = [];
      if (nhomKh && nhomKh.length > 0) {
        nhomKh.map((item) => { options.push({ value: item.Id, label: item.Ten }) }
        );
      }
      return options;
    }
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div className="mb-2">
            <InputGroup>
              <Select
                styles={customSelectStyles}
                className="form-control p-0"
                placeholder="--Chọn nhóm--"
                value={selectedOption}
                onChange={(e) => this.handleNhomKhChange(e)}
                options={getOptionNhomKh()}
              />
              <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                <Button color="success" onClick={e => this.toggleNhomKhDlg()}>
                  <i className="fa fa-plus mr-1"></i>Thêm nhóm
                </Button>
              </InputGroupAddon>
            </InputGroup>
            <em className="error invalid-feedback">{this.state.formError.NhomKhId}</em>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 row ml-0 mr-0">
              <div className="col-sm-6 p-1">
                <Alert color="primary">Danh sách khách hàng chưa phân nhóm</Alert>
                <InputGroup>
                  <Input placeholder="Mã, tên, địa chỉ khách hàng"
                    onChange={e => this.handleSearchChange(e, false)}
                    onKeyDown={e => this.keyPress(e, false)}
                  />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" onClick={e => this.fetchDetails(false)}>
                      <i className="fa fa-search"></i> Tìm kiếm
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" className="text-left">Mã</th>
                      <th scope="col" className="text-left">Tên khách hàng</th>
                      <th scope="col" width="50" className="text-left">
                        <ButtonExt
                          btnClass="text-primary"
                          iconClass="fa-arrow-right fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.confirmBatchUpdateClick(unSetted.items, false)}
                          // permission={BtnPermissions.KhachHangNhom.ADD_OR_UPDATE} 
                          permission={""}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {unSetted.items && !!unSetted.items.length && (
                      unSetted.items.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-left">{res.Ma}</td>
                          <td className="text-left">
                            {res.Ten}
                            <div className="item_unit pl-1">{res.DiaChi}/{'\u00A0'}{res.DienThoai}</div>
                          </td>
                          <td className="text-left">
                            <ButtonExt
                              btnClass="text-primary"
                              iconClass="fa-arrow-right fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateKhachHang(res, false)}
                              // permission={BtnPermissions.KhachHangNhom.ADD_OR_UPDATE} 
                              permission={""}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                {unSetted.total_record > unSetted.per_page && (
                  <nav>
                    <Pagination
                      activePage={unSetted.page}
                      itemsCountPerPage={unSetted.per_page}
                      totalItemsCount={unSetted.total_record}
                      pageRangeDisplayed={5}
                      onChange={pageNumber => this.handlePageChange(pageNumber, false)}
                    />
                  </nav>
                )}
              </div>
              <div className="col-sm-6 p-1">
                <Alert color="success">Danh sách khách hàng đã phân nhóm </Alert>
                <InputGroup>
                  <Input placeholder="Mã, tên, địa chỉ khách hàng"
                    onChange={e => this.handleSearchChange(e, true)}
                    onKeyDown={e => this.keyPress(e, true)}
                  />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" onClick={e => this.fetchDetails(true)}>
                      <i className="fa fa-search"></i> Tìm kiếm
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="50" className="text-center">
                        <ButtonExt
                          btnClass="text-danger"
                          iconClass="fa-arrow-left fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.confirmBatchUpdateClick(setted.items, true)}
                          permission={BtnPermissions.NguoiDungRole.ADD_OR_UPDATE} />
                      </th>
                      <th scope="col" className="text-left">Mã</th>
                      <th scope="col" className="text-left">Tên khách hàng</th>
                    </tr>
                  </thead>
                  <tbody>
                    {setted.items && !!setted.items.length && (
                      setted.items.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-center">
                            <ButtonExt
                              btnClass="text-danger"
                              iconClass="fa-arrow-left fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateKhachHang(res, true)}
                              permission={BtnPermissions.NguoiDungRole.ADD_OR_UPDATE} />
                          </td>
                          <td className="text-left">{res.Ma}</td>
                          <td className="text-left">
                            {res.Ten}
                            <div className="item_unit pl-1">{res.DiaChi}/{'\u00A0'}{res.DienThoai}</div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                {setted.total_record > setted.per_page && (
                  <nav>
                    <Pagination
                      activePage={setted.page}
                      itemsCountPerPage={setted.per_page}
                      totalItemsCount={setted.total_record}
                      pageRangeDisplayed={5}
                      onChange={pageNumber => this.handlePageChange(pageNumber, true)}
                    />
                  </nav>
                )}
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
          <NhomKhEdit
            isOpenDlg={this.state.isOpenDlg}
            requesting={requesting}
            errors={errors}
            messages={messages}
            item={this.state.item}
            updateNhomKh={() => this.updateNhomKh()}
            onClose={() => this.toggleNhomKhDlg()}
            updateDataFields={(data) => this.updateDataFields(data)}
          />
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  khachHangNhom: state.khachHangNhom,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  khachHangNhomUpdateRequest: khachHangNhomAction.khachHangNhomUpdateRequest,
  khachHangNhomDetailRequest: khachHangNhomAction.khachHangNhomDetailRequest,
  updateNhomKhachHangInfo: khachHangNhomAction.updateNhomKhachHangInfo,
  chuongTrinhListNhomKhRequest: chuongTrinhListNhomKhRequest
})(KhachHangNhom)
const formed = reduxForm({
  form: 'khachHangNhom',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/KhachHangNhom/KhachHangNhom.js